import React from 'react';
import { CheckboxInput } from '@td-client-frontend/common';
import { IncentiveLabel } from '../@types/Marketing';

export interface NestedCheckboxData {
  checked: boolean;
  label: IncentiveLabel;
  children: NestedCheckboxData[];
}
interface NestedCheckboxProps extends NestedCheckboxData {
  isDisabled?: boolean;
  className?: string;
  lvl?: number;
  onChange: (val: NestedCheckboxData) => void;
}

export const NestedCheckbox = ({
  checked,
  label,
  children,
  isDisabled = false,
  onChange,
  className = '',
  lvl = 1
}: NestedCheckboxProps) => {
  const handleChange = (_checked: boolean) =>
    onChange({
      checked: _checked,
      label,
      children: nestedCheck(children, _checked)
    });

  const nestedCheck = (_children: NestedCheckboxData[], _checked: boolean): NestedCheckboxData[] =>
    _children?.map((child) => ({
      ...child,
      checked: _checked,
      children: nestedCheck(child.children, _checked)
    }));

  const handleChildChange = (_child: NestedCheckboxData, _idx: number) => {
    if (children) {
      children[_idx] = _child;
      onChange({
        checked: children.every((child) => child.checked),
        label,
        children
      });
    }
  };

  return (
    <div className={className}>
      <div className="flex flex-row border-b-1 mt-2 w-full border-gray">
        <CheckboxInput
          colorType="blue"
          data-testid={`nested-checkbox-lvl-${lvl}`}
          checked={checked}
          disabled={isDisabled}
          onChange={(e) => handleChange(e.target.checked)}
          className="mb-5"
        />
        <span>{label}</span>
      </div>
      {children && (
        <div className="ml-10 sm:ml-6 md:ml-10">
          {children.map((child, idx) => (
            <NestedCheckbox
              key={`nested-checkbox-lvl-${lvl}-${idx}`}
              lvl={lvl + 1}
              checked={child.checked !== undefined ? child.checked : checked}
              isDisabled={isDisabled}
              label={child.label}
              children={child.children}
              onChange={(val) => handleChildChange(val, idx)}
            />
          ))}
        </div>
      )}
    </div>
  );
};
